import React, { useState, useContext } from "react";
import { AppContext } from "../../components/States/AppContext";
import { Link } from "react-router-dom";

// components
import TopBar from "../../components/MonitorComponents/TopBar";
import MessageBox from "../../components/MonitorComponents/MessageBox";
import PatientDemo from "../../components/MonitorComponents/PatientDemo";

// styles
import { LandScapeContainer } from "./LandScapePage.elements";
import {
  SettingsTopLine,
  SettingsBack1,
  SettingsClose,
} from "../../components/Settings/SettingBar.elements";
import {
  GrayBox,
  ToggleSwitch,
  ToggleSwitchContainer,
  TrendBanner,
  TrendMenuText,
  TrendMenuTextContainer,
  TrendsToggleBtnCardiac,
  TrendsToggleBtnStandard,
} from "./Trends.elements";

// icons
import { AiOutlineClose } from "react-icons/ai";
import { BsGraphUp } from "react-icons/bs";
import { MdOutlineArrowBackIosNew } from "react-icons/md";

const TrendsSetting = () => {
  const { state, setState } = useContext(AppContext);

  const [isOn, setIsOn] = useState(false);

  const handleToggle = () => {
    setIsOn(!isOn);
  };

  function handleBackButtonClick() {
    const scrollPosition = window.pageYOffset;
    window.history.back();
    setTimeout(() => {
      const hash = window.location.hash;
      if (hash) {
        const element = document.querySelector(hash);
        if (element) {
          window.scrollTo(0, element.offsetTop);
        }
      } else {
        window.scrollTo(0, scrollPosition);
      }
    }, 0);
  }

  function toggleView() {
    setState((prevState) => ({
      ...prevState,
      trendsSetting:
        prevState.trendsSetting === "Standard" ? "Cardiac" : "Standard",
    }));
  }

  function changeTrends() {
    setState((prevState) => ({
      ...prevState,
      trendsType:
        prevState.trendsType === "Tabular Trends"
          ? "Graph Trend"
          : "Tabular Trends",
    }));
  }

  return (
    <>
      <LandScapeContainer>
        <TopBar />
        <MessageBox landscape />
        <PatientDemo />
        <SettingsTopLine>
          Trends
          <SettingsBack1 onClick={handleBackButtonClick}>
            <MdOutlineArrowBackIosNew></MdOutlineArrowBackIosNew>
          </SettingsBack1>
          <Link to="/">
            <SettingsClose>
              <AiOutlineClose></AiOutlineClose>
            </SettingsClose>
          </Link>
        </SettingsTopLine>

        <GrayBox>
          <TrendMenuTextContainer>
            <TrendMenuText>View</TrendMenuText>

            <ToggleSwitchContainer>
              <TrendsToggleBtnStandard
                onClick={toggleView}
                active={state.trendsSetting}
              >
                Standard
              </TrendsToggleBtnStandard>
              <TrendsToggleBtnCardiac
                onClick={toggleView}
                active={state.trendsSetting}
              >
                Cardiac
              </TrendsToggleBtnCardiac>
            </ToggleSwitchContainer>
          </TrendMenuTextContainer>

          <TrendMenuTextContainer>
            <TrendMenuText>Optimum Scale: {isOn ? "On" : "Off"}</TrendMenuText>
            <ToggleSwitchContainer>
              <ToggleSwitch isOn={isOn} onClick={handleToggle}></ToggleSwitch>
            </ToggleSwitchContainer>
          </TrendMenuTextContainer>

          <Link to="/trends">
            <TrendMenuTextContainer>
              <TrendBanner onClick={changeTrends}>
                <BsGraphUp></BsGraphUp>
                {state.trendsType === "Tabular Trends"
                  ? "Graph Trend"
                  : "Tabular Trends"}
              </TrendBanner>
            </TrendMenuTextContainer>
          </Link>
        </GrayBox>
      </LandScapeContainer>
    </>
  );
};

export default TrendsSetting;
